import type { INavBarLink } from './types'

const getServicePathOnly = (url: string) => {
  const urlSplitted = url.split('/')
  return urlSplitted.slice(0, urlSplitted.length - 1).join('/')
}

export const checkUrlMatch = (locationPathname: string, url: string): boolean => {
  const servicePath = getServicePathOnly(url)
  return locationPathname.includes(servicePath)
}

export const subMenuMatch = (submenu: INavBarLink[]): boolean => {
  return submenu.some(({ submenu, url }) => {
    if (submenu?.length) {
      return subMenuMatch(submenu) || location.pathname.includes(url)
    }
    return location.pathname.includes(url)
  })
}
